"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var prism_icons_1 = require("@octanner/prism-icons");
var react_1 = __importDefault(require("react"));
var colors_1 = require("../ThemeProvider/colors");
var usePixelSize = function (size) {
    var dimensions;
    switch (size) {
        case 'small':
            dimensions = {
                width: 16,
                height: 16,
                fontSize: 10,
                margin: '0px',
            };
            break;
        case 'medium':
            dimensions = {
                width: 18,
                height: 18,
                fontSize: 12,
                margin: '1px 2px',
            };
            break;
    }
    var IconWrapper = (0, material_1.styled)('div', { name: 'IconWrapper' })(__assign(__assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', color: colors_1.tannerGray['500'] }, dimensions), { borderRadius: 50, boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.25)' }));
    return IconWrapper;
};
var Switch = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, props = __rest(_a, ["size"]);
    var IconWrapper = usePixelSize(size);
    return (react_1.default.createElement(Switch_1.default, __assign({ size: size, checkedIcon: react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(prism_icons_1.Check, null)), icon: react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(prism_icons_1.Close, null)) }, props)));
};
exports.default = Switch;
//# sourceMappingURL=index.js.map